import { createFileRoute } from '@tanstack/react-router';

import { buildSeoHead, ROUTE_META } from '@src/corelib/seo';
import { DefaultLayout } from '@src/layout';
import { CompareHub } from '@src/pages/Compare/CompareHub';

export const Route = createFileRoute('/compare/')({
  head: () => buildSeoHead({ path: '/compare', ...ROUTE_META['/compare'] }),
  component: CompareHubPage,
});

function CompareHubPage() {
  return (
    <DefaultLayout>
      <CompareHub />
    </DefaultLayout>
  );
}
